module.exports = {"id":"dp2_4l1q2","text":"Collaborating through Digital Technologies","instructions":"Digital collaboration tools can help people work together without being in the same place.","multiselect":false,"questionType":"PickOne","random":false,"options":[{"id":"dp2_4l1q2-a1","text":"True","score":1.8},{"id":"dp2_4l1q2-a2","text":"Not sure","score":0},{"id":"dp2_4l1q2-a3","text":"False","score":0}],"groupTitle":"Digital Profiler Knowledge Matrix","category":"2.4"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.4/l1q2.json
// module id = 1046
// module chunks = 41